module.exports = __webpack_public_path__ + "img/hokenso-internship-1.79a50efa.jpg";